import { HowTo } from '../types';
import { accountHowTos } from './account';
import { adminHowTos } from './admin';
import { attendanceHowTos } from './attendance';
import { dashboardHowTos } from './dashboard';
import { documentsHowTos } from './documents';
import { postsHowTos } from './posts';
import { reportsHowTos } from './reports';
import { scheduleHowTos } from './schedule';
import { supportHowTos } from './support';

/** Every How To in the app. Order within a section follows this array. */
export const HOW_TOS: HowTo[] = [
  ...dashboardHowTos,
  ...postsHowTos,
  ...scheduleHowTos,
  ...attendanceHowTos,
  ...reportsHowTos,
  ...documentsHowTos,
  ...adminHowTos,
  // After the pages, as Security and Support are last in HELP_SECTIONS: these
  // are about the device, and about getting help, rather than the work.
  ...accountHowTos,
  ...supportHowTos,
];

export const howToByKey = (key: string | null | undefined): HowTo | null =>
  (key ? HOW_TOS.find(h => h.key === key) ?? null : null);
